import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignUpPage } from "@/features/signin/SignUpPage";

const search = z.object({
  state: z.enum(["loading", "empty", "error"]).optional(),
});

/** Public sign-up: the account step of the setup wizard, in the sign-in split frame. Sits outside the _app layout. */
export const Route = createFileRoute("/sign-up")({
  validateSearch: search,
  component: SignUpRoute,
});

function SignUpRoute() {
  const { state } = Route.useSearch();
  return <SignUpPage state={state} />;
}
